import { render, staticRenderFns } from "./Blacklist.vue?vue&type=template&id=04c8759b&scoped=true&"
import script from "./Blacklist.vue?vue&type=script&lang=js&"
export * from "./Blacklist.vue?vue&type=script&lang=js&"
import style0 from "./Blacklist.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Blacklist.vue?vue&type=style&index=1&id=04c8759b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c8759b",
  null
  
)

export default component.exports